<template>
  <div>
    <!--搜索-->
    <div class="box study_top">
      <div class="wrap w1200 search">
        <dl>
          <dt>首页 - 课件资源 - 课程列表</dt>
          <dd><input v-model="filter.courseOrTeacherName" type="text" class="put_txt paddingR_0" placeholder="搜索课程、讲师" @keyup.13="searchByFilter(null, null, filter.courseOrTeacherName, null)" /><input type="button" class="put_btn" value="搜 索" @click="searchByFilter(null, null, filter.courseOrTeacherName, null)"/>
          </dd>
        </dl>
      </div>
    </div>
    <!--/搜索-->
    <!--筛选-->
    <div class="wrap w1200 study_cat">
      <dl>
        <dt>按分类：</dt>
        <dd><a href="javascript:;" @click="searchByFilter('', null, null, $event)">全部</a><a href="javascript:;" v-for="item in trees" :key="item.id" @click="searchByFilter(item.id, null, null, $event)">{{item.name}}</a><!--<a href="javascript:;" class="focus">员工培训</a>--></dd>
      </dl>
      <div class="clear"></div>
      <dl class="mt25">
        <dt>讲师：</dt>
        <dd><a href="javascript:;" @click="searchByFilter(null, '', null, $event)">全部</a><a href="javascript:;" v-for="item in teacherList" :key="item.id" @click="searchByFilter(null, item.id, null, $event)">{{item.name}}</a></dd>
      </dl>
    </div>
    <!--/筛选-->
    <!--课件列表-->
    <div class="box study_list">
      <div class="wrap w1200">
        <div class="top_tit">
          <h3>课程列表</h3>
          <a href="javascript:;" class="study_prv" title="上一页" @click="page_click('prev')"></a>
          <a href="javascript:;" class="study_next" title="下一页" @click="page_click('next')"></a>
        </div>
        <div class="list">
          <a href="javascript:;" v-for="item in courseList" :key="item.id" @click="course_detail(item.id)">
            <dl>
              <dt>
                <img v-if="item.faceUrl" :src="item.faceUrl" :title="item.name" />
                <img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/class_img.jpg" :title="item.name" />
                <span class="price_r" v-if="item.coursePriceList[0].price && item.coursePriceList[0].price != '0'">￥{{item.coursePriceList[0].price}}</span>
                <span class="price_r" v-if="!item.coursePriceList[0].price || item.coursePriceList[0].price == '0'">免费</span>
                <span class="man_num_r">{{item.learnCount}}</span>
              </dt>
              <dd>
                <h3 class="single_ellipsis">{{item.name}}</h3>
                <p v-if="item.teacherList && item.teacherList.length>0">讲师：{{item.teacherList[0].teacherName}}<span v-if="item.teacherList.length>1">等</span></p>
                <p v-if="!item.teacherList">讲师：暂无</p>
              </dd>
            </dl>
          </a>
        </div>
      </div>
    </div>
    <!--/课件列表-->
  </div>
</template>
<script>

export default {
  components: { },
  data () {
    return {
      filter: {
        pageNo: 1,
        pageSize: 12,
        courseClassifiId: '',
        courseOrTeacherName: '',
        teacherIds: []
      },
      trees: [],
      teacherList: [],
      courseList: [],
      currentPage: 1,
      pages: 0,
      courseCnt: 0
    }
  },
  created () {
    this.getCourses(this.filter)
    this.getCourseClassification()
    this.getTeachers()
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  computed: {},
  methods: {
    page_click (type) {
      if (type=='prev') {
        if (this.currentPage > 1) {
          this.filter.pageNo = this.currentPage - 1
          this.currentPage--
          this.getCourses(this.filter)
        }
      } else if (type=='next') {
        if (this.currentPage < this.pages) {
          this.filter.pageNo = this.currentPage + 1
          this.currentPage++
          this.getCourses(this.filter)
        }
      }
    },
    searchByFilter (classificationId, teacherId, courseOrTeacherName, event) {
      this.currentPage = 1
      this.filter.pageNo = 1
      if (event != null) {
        $(event.target).siblings('a').removeClass("focus")
        $(event.target).addClass('focus')
      }
      if (classificationId != null) {
        this.filter.courseClassifiId = classificationId
      }
      if (teacherId != null) {
        this.filter.teacherIds = []
        if (teacherId != '') {
          this.filter.teacherIds.push(teacherId)
        }
      }
      if (courseOrTeacherName != null) {
        this.filter.courseOrTeacherName = courseOrTeacherName
      }
      this.getCourses(this.filter)
    },
    getCourses (filter) {
      // course/courses/teacher/page
      this.$api.post(this.$global.bylApiPath, '/studyItemScopes/findCourseList', filter, r => {
        if (r.data && r.data.length>0) {
          this.courseList = r.data
        } else {
          this.courseList = r.data
        }
        this.pages = Math.ceil(r.cntData / this.filter.pageSize)
      })
    },
    getCourseClassification () {
      this.$api.post(this.$global.courseApiPath, '/course/classification/list', {}, r => {
        this.trees = r.data
      })
    },
    getTeachers () {
      this.$api.post(this.$global.teacherApiPath, '/teacher/teachers', {delFlag: '0'}, r => {
        if (r.data && r.data.length>0) {
          this.teacherList = r.data
        }
      })
    },
    course_detail (id) {
      this.$router.push({path: '/byl/courseDetail/'+ id})
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/course/list.vue